import { StyleSheet } from 'react-native';
import { spacing } from '../../shared/theme/spacing'
import { typography } from '../../shared/theme/typography'
import { ticketColors, ticketFonts } from '../../shared/theme/ticketColors';

const sans = { fontFamily: ticketFonts.sans } as const;
const mono = { fontFamily: ticketFonts.mono } as const;

export const billingStyles = StyleSheet.create({
  screenGap: {
    gap: spacing.lg,
    paddingBottom: spacing.xl * 2,
    width: '100%',
    alignSelf: 'stretch',
    alignItems: 'stretch',
  },
  introLead: {
    ...typography.body,
    ...sans,
    color: ticketColors.ink2,
    lineHeight: 22,
  },
  banner: {
    borderRadius: 10,
    borderWidth: 1,
    padding: spacing.md,
    gap: spacing.xs,
  },
  bannerAccent: {
    borderColor: ticketColors.brandBorder,
    backgroundColor: ticketColors.brandSoft,
  },
  bannerSuccess: {
    borderColor: 'rgba(74, 222, 128, 0.35)',
    backgroundColor: 'rgba(74, 222, 128, 0.08)',
  },
  bannerInfo: {
    borderColor: 'rgba(96, 165, 250, 0.35)',
    backgroundColor: 'rgba(96, 165, 250, 0.08)',
  },
  bannerWarning: {
    borderColor: 'rgba(250, 204, 21, 0.55)',
    backgroundColor: 'rgba(250, 204, 21, 0.12)',
  },
  bannerMeta: {
    ...typography.caption,
    ...mono,
    fontSize: 10,
    fontWeight: '700',
    letterSpacing: 1.2,
    textTransform: 'uppercase',
    color: '#6bcf8e',
  },
  bannerTitle: {
    ...typography.title3,
    ...sans,
    color: ticketColors.ink,
    fontWeight: '700',
    fontSize: 15,
    lineHeight: 22,
  },
  bannerBody: {
    ...typography.caption,
    ...sans,
    color: ticketColors.ink2,
    fontSize: 13,
    lineHeight: 18,
  },
  bannerPlanName: {
    ...sans,
    color: ticketColors.ink,
    fontWeight: '700',
  },
  bannerPrimaryBtn: {
    alignSelf: 'flex-start',
    borderRadius: 8,
    backgroundColor: ticketColors.gold,
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
    marginTop: spacing.sm,
  },
  bannerPrimaryBtnText: {
    ...sans,
    color: ticketColors.goldInk,
    fontWeight: '700',
    fontSize: 15,
  },
  planCard: {
    width: '100%',
    alignSelf: 'stretch',
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.rule,
    backgroundColor: ticketColors.paper,
    padding: spacing.md,
    gap: spacing.sm,
    overflow: 'visible',
  },
  planCardInRow: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    minWidth: 220,
    alignSelf: 'stretch',
  },
  planCardFill: {
    flex: 1,
    width: '100%',
  },
  planCardCurrent: {
    borderColor: ticketColors.brandBorder,
    backgroundColor: ticketColors.brandSoft,
  },
  planCardHighlighted: {
    borderWidth: 1,
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.brandSoft,
  },
  planCardFeatured: {
    borderWidth: 1,
    borderColor: ticketColors.brandBorder,
    backgroundColor: ticketColors.paper,
  },
  /** Fila ancha debajo de Gratis/Crece (no pelear por ancho en el row). */
  planCardContact: {
    borderStyle: 'dashed',
    borderColor: ticketColors.rule,
    backgroundColor: ticketColors.paper,
    width: '100%',
    flexGrow: 0,
    flexShrink: 0,
    minWidth: 0,
    overflow: 'visible',
  },
  planCardContactWide: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.md,
  },
  planCardContactMain: {
    minWidth: 0,
    gap: spacing.sm,
  },
  planCardContactMainWide: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 280,
  },
  planCardCompact: {
    minWidth: 200,
    paddingVertical: spacing.md,
  },
  planCardMuted: {
    opacity: 0.78,
  },
  featuredRibbon: {
    alignSelf: 'flex-start',
    marginTop: -spacing.xs,
    marginBottom: -spacing.xs,
    borderRadius: 8,
    backgroundColor: ticketColors.gold,
    paddingHorizontal: spacing.sm,
    paddingVertical: 4,
  },
  featuredRibbonText: {
    ...sans,
    fontSize: 10,
    fontWeight: '800',
    letterSpacing: 0.5,
    textTransform: 'uppercase',
    color: ticketColors.goldInk,
  },
  planCtaStack: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.sm,
  },
  planCtaFlex: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 120,
    minWidth: 0,
  },
  planHighlights: {
    gap: 4,
    marginTop: 2,
  },
  planHighlightLine: {
    ...typography.caption,
    ...sans,
    color: ticketColors.ink2,
    fontSize: 12,
    lineHeight: 18,
  },
  offersBlock: {
    gap: spacing.md,
    width: '100%',
    alignSelf: 'stretch',
  },
  offersLead: {
    ...typography.body,
    ...sans,
    color: ticketColors.ink2,
    lineHeight: 22,
  },
  offersFootnote: {
    ...typography.caption,
    ...sans,
    color: ticketColors.ink3,
    fontSize: 12,
    lineHeight: 18,
    fontStyle: 'italic',
  },
  legacyBanner: {
    ...typography.caption,
    ...sans,
    marginTop: 10,
    paddingHorizontal: 12,
    paddingVertical: 10,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: ticketColors.brandBorderSoft,
    backgroundColor: ticketColors.brandSoft,
    color: ticketColors.brandInk,
    fontSize: 13,
    lineHeight: 19,
  },
  legacyBannerTitle: {
    ...sans,
    color: ticketColors.brandInk,
    fontSize: 13,
    lineHeight: 19,
    fontWeight: '700',
    marginBottom: 2,
  },
  legacyBannerBody: {
    ...sans,
    color: ticketColors.brandInk,
    fontSize: 13,
    lineHeight: 19,
  },
  currentPlanCard: {
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.rule,
    backgroundColor: ticketColors.paper,
    padding: spacing.md,
    gap: 6,
    width: '100%',
    alignSelf: 'stretch',
  },
  currentPlanLabel: {
    ...typography.caption,
    ...sans,
    color: ticketColors.ink3,
    fontWeight: '700',
    letterSpacing: 0.8,
    fontSize: 11,
    textTransform: 'uppercase',
  },
  currentPlanName: {
    ...typography.titleLg,
    ...sans,
    color: ticketColors.ink,
    fontWeight: '800',
    fontSize: 26,
    lineHeight: 32,
    letterSpacing: -0.3,
  },
  /** Precio + canal de cobro bajo el nombre del plan actual. */
  currentPlanPriceLine: {
    ...typography.caption,
    ...sans,
    color: ticketColors.ink2,
    fontSize: 13,
    lineHeight: 18,
    marginTop: 2,
  },
  currentPlanTrialHint: {
    ...typography.caption,
    ...sans,
    color: ticketColors.gold,
    fontWeight: '700',
    fontSize: 13,
    marginTop: 0,
  },
  currentPlanUsageRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 14,
    marginTop: 2,
  },
  currentPlanUsageItem: {
    ...typography.caption,
    ...sans,
    color: ticketColors.ink2,
    fontSize: 13,
    lineHeight: 18,
  },
  currentPlanUsageValue: {
    ...mono,
    color: ticketColors.ink,
    fontWeight: '700',
  },
  currentPlanUsage: {
    marginTop: spacing.xs,
  },
  usageMeters: {
    gap: spacing.sm,
    marginTop: spacing.xs,
  },
  usageMeter: {
    gap: 4,
  },
  usageMeterHead: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  usageMeterLabel: {
    ...typography.caption,
    ...sans,
    color: ticketColors.ink2,
    fontSize: 13,
  },
  usageMeterValue: {
    ...mono,
    color: ticketColors.ink,
    fontWeight: '700',
    fontSize: 12,
    fontVariant: ['tabular-nums'],
  },
  usageMeterTrack: {
    height: 5,
    borderRadius: 3,
    backgroundColor: ticketColors.ruleSoft,
    overflow: 'hidden',
  },
  usageMeterFill: {
    height: '100%',
    borderRadius: 3,
  },
  currentPlanHighlights: {
    marginTop: spacing.sm,
    gap: 4,
  },
  currentPlanHighlightLine: {
    ...typography.caption,
    ...sans,
    color: ticketColors.ink2,
    lineHeight: 18,
  },
  badgeTrial: {
    borderColor: 'rgba(74, 222, 128, 0.45)',
    backgroundColor: 'rgba(74, 222, 128, 0.12)',
  },
  badgeTrialText: {
    color: '#4ade80',
  },
  planHeaderRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: spacing.sm,
    flexWrap: 'nowrap',
  },
  planName: {
    ...typography.titleLg,
    ...sans,
    color: ticketColors.ink,
    fontWeight: '700',
    fontSize: 17,
    lineHeight: 22,
    flexShrink: 1,
  },
  planTagline: {
    ...typography.caption,
    ...sans,
    color: ticketColors.ink2,
    fontSize: 12,
    lineHeight: 16,
    marginTop: 2,
    flexShrink: 1,
  },
  planPriceHint: {
    ...typography.caption,
    ...sans,
    color: ticketColors.ink3,
    fontSize: 11,
    lineHeight: 16,
    flexShrink: 1,
  },
  badge: {
    borderRadius: 8,
    paddingHorizontal: spacing.sm,
    paddingVertical: 4,
    borderWidth: 1,
    flexShrink: 0,
  },
  badgeCurrent: {
    borderColor: ticketColors.brandBorder,
    backgroundColor: ticketColors.brandSoft,
  },
  badgePending: {
    borderColor: 'rgba(250, 204, 21, 0.45)',
    backgroundColor: 'rgba(250, 204, 21, 0.12)',
  },
  badgeRecommended: {
    borderColor: ticketColors.brandBorder,
    backgroundColor: ticketColors.brandSoft,
  },
  badgeText: {
    ...typography.caption,
    ...sans,
    fontSize: 10,
    fontWeight: '800',
    letterSpacing: 0.4,
    textTransform: 'uppercase',
    color: ticketColors.gold,
    flexShrink: 0,
  },
  priceRow: {
    flexDirection: 'row',
    alignItems: 'baseline',
    gap: spacing.xs,
    flexWrap: 'wrap',
  },
  priceValue: {
    ...mono,
    fontSize: 24,
    fontWeight: '700',
    color: ticketColors.ink,
    fontVariant: ['tabular-nums'],
    flexShrink: 1,
    letterSpacing: -0.3,
  },
  pricePeriod: {
    ...typography.caption,
    ...sans,
    color: ticketColors.ink3,
    fontWeight: '500',
    fontSize: 12,
  },
  trialPill: {
    alignSelf: 'flex-start',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: 'rgba(74, 222, 128, 0.4)',
    backgroundColor: 'rgba(74, 222, 128, 0.1)',
    paddingHorizontal: spacing.sm,
    paddingVertical: 4,
  },
  trialPillText: {
    ...typography.caption,
    ...sans,
    color: ticketColors.ok,
    fontWeight: '700',
    flexShrink: 1,
  },
  benefitsSectionTitle: {
    ...typography.caption,
    ...sans,
    color: ticketColors.ink3,
    fontWeight: '700',
    letterSpacing: 0.4,
    textTransform: 'uppercase',
  },
  cumulativeLead: {
    ...typography.body,
    ...sans,
    color: ticketColors.ink,
    fontWeight: '700',
    lineHeight: 22,
  },
  benefitGroup: {
    gap: spacing.sm,
  },
  benefitGroupLabel: {
    ...typography.caption,
    ...sans,
    color: ticketColors.ink3,
    fontWeight: '700',
    letterSpacing: 0.4,
    textTransform: 'uppercase',
    fontSize: 11,
  },
  benefitRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: spacing.sm,
  },
  benefitIconWrap: {
    width: 22,
    marginTop: 1,
    alignItems: 'center',
  },
  benefitTextBlock: {
    flex: 1,
    minWidth: 0,
    gap: 2,
  },
  benefitTitle: {
    ...typography.body,
    ...sans,
    color: ticketColors.ink,
    fontWeight: '600',
    lineHeight: 20,
    flexShrink: 1,
  },
  benefitTitleMuted: {
    color: ticketColors.ink3,
    textDecorationLine: 'line-through',
  },
  benefitDescription: {
    ...typography.caption,
    ...sans,
    color: ticketColors.ink2,
    lineHeight: 18,
    flexShrink: 1,
  },
  planCardsRow: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
    gap: spacing.md,
    alignItems: 'stretch',
    width: '100%',
  },
  planCardsStack: {
    gap: spacing.lg,
    width: '100%',
  },
  planCardsBlock: {
    gap: spacing.md,
    width: '100%',
    alignSelf: 'stretch',
  },
  currentPlanWide: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.lg,
    alignItems: 'flex-start',
  },
  currentPlanCol: {
    flexGrow: 1,
    flexBasis: 'auto',
    minWidth: 240,
    gap: spacing.sm,
  },
  /** Empuja el CTA al fondo de la tarjeta para alinear botones entre planes de distinto alto. */
  planCtaBottom: {
    marginTop: 'auto',
  },
  /** CTA de conversión Crece — acento naranja del proto (`--crece`). */
  ctaPrimary: {
    marginTop: spacing.xs,
    backgroundColor: ticketColors.crece,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 9,
    paddingHorizontal: 12,
    minHeight: 40,
    gap: 2,
  },
  ctaPrimaryText: {
    ...typography.body,
    ...sans,
    color: ticketColors.creceInk,
    fontWeight: '700',
    fontSize: 12,
    textAlign: 'center',
    flexShrink: 1,
  },
  ctaSecondary: {
    marginTop: spacing.xs,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: ticketColors.rule,
    backgroundColor: ticketColors.paper,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 9,
    paddingHorizontal: 12,
    minHeight: 40,
    flexShrink: 0,
  },
  ctaSecondaryText: {
    ...typography.body,
    ...sans,
    color: ticketColors.ink,
    fontWeight: '700',
    fontSize: 12,
    textAlign: 'center',
  },
  ctaContact: {
    borderColor: ticketColors.brandBorder,
    backgroundColor: ticketColors.brandSoft,
    alignSelf: 'flex-start',
    marginTop: 0,
    paddingHorizontal: spacing.xl,
    minWidth: 220,
  },
  /** Mobile: CTA pegado al contenido, sin hueco por flexBasis del bloque wide. */
  ctaContactStack: {
    alignSelf: 'stretch',
    width: '100%',
    minWidth: 0,
  },
  /** Ghost destructivo (cancelar suscripción en el proveedor). */
  ctaDangerGhost: {
    marginTop: spacing.xs,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: 'rgba(185, 28, 28, 0.35)',
    backgroundColor: ticketColors.paper,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 9,
    paddingHorizontal: 12,
    minHeight: 40,
    flexShrink: 0,
  },
  ctaDangerGhostText: {
    ...typography.body,
    ...sans,
    color: ticketColors.bad,
    fontWeight: '700',
    fontSize: 12,
    textAlign: 'center',
  },
  ctaDisabled: {
    borderRadius: 8,
    borderWidth: 1,
    borderStyle: 'dashed',
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper2,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 9,
    minHeight: 40,
  },
  ctaDisabledText: {
    ...typography.body,
    ...sans,
    color: ticketColors.ink3,
    fontWeight: '700',
    fontSize: 12,
    textAlign: 'center',
    flexShrink: 1,
  },
  errorText: {
    ...typography.caption,
    ...sans,
    color: ticketColors.bad,
    lineHeight: 18,
    textAlign: 'center',
  },
  /** Letra chica legal/alcance (abono por negocio): más chica que caption. */
  finePrint: {
    ...typography.caption,
    ...sans,
    color: ticketColors.ink3,
    fontSize: 11,
    lineHeight: 16,
    textAlign: 'center',
  },
  linkBtn: {
    alignItems: 'center',
    paddingVertical: spacing.sm,
  },
  linkText: {
    ...typography.body,
    ...sans,
    color: ticketColors.gold,
    fontWeight: '700',
    textDecorationLine: 'underline',
  },
});
